import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const BuildVoyahConfig = () => {
  const [config, setConfig] = useState(null);

  const [basePrice, setBasePrice] = useState("");
  const [currency, setCurrency] = useState("");

  // Dynamic prices
  const [colors, setColors] = useState([]);
  const [equipment, setEquipment] = useState([]);

  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState(null);

  // =====================================================
  // LOAD CONFIG (BASE PRICE + CURRENCY)
  // =====================================================
  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/VFreeBuildConfig`);
        setConfig(res.data);
        setBasePrice(res.data.basePrice);
        setCurrency(res.data.currency);
      } catch (err) {
        console.error(err);
        setError("Failed to load config.");
      }
    };

    load();
  }, []);

  // =====================================================
  // LOAD PRICES (COLORS + EQUIPMENT)
  // =====================================================
  useEffect(() => {
    const loadPrices = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/VFreePrices`);
        setColors(res.data.colors);
        setEquipment(res.data.equipment);
      } catch (err) {
        console.error(err);
        setError("Failed to load prices.");
      }
    };

    loadPrices();
  }, []);

  // =====================================================
  // SAVE CHANGES
  // =====================================================
  const saveChanges = async () => {
    setSaving(true);
    setSaved(false);
    setError(null);

    try {
      const token = localStorage.getItem("token");

      // Save main config
      await axios.put(
        `${API_BASE}/api/VFreeBuildConfig`,
        {
          basePrice: Number(basePrice),
          currency: currency.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Save prices
      await axios.put(
        `${API_BASE}/api/VFreePrices`,
        {
          colors: colors.map((c) => ({
            id: c.id,
            colorName: c.name,
            additionalPrice: Number(c.price),
          })),
          equipment: equipment.map((e) => ({
            id: e.id,
            equipmentName: e.name,
            additionalPrice: Number(e.price),
          })),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      console.error(err);
      setError("Failed to save changes.");
    }

    setSaving(false);
  };

  if (!config || colors.length === 0 || equipment.length === 0)
    return <p style={{ padding: 40 }}>Loading...</p>;

  return (
    <div style={{ padding: "40px", maxWidth: "700px" }}>
      <h1 style={{ marginBottom: "20px" }}>VOYAH FREE — Build Config</h1>

      {error && (
        <div style={{ marginBottom: 20, color: "red", fontSize: 15 }}>
          {error}
        </div>
      )}

      {/* ===================================== */}
      {/* BASE PRICE */}
      {/* ===================================== */}
      <div style={{ marginBottom: "20px" }}>
        <label style={{ display: "block", marginBottom: 6 }}>Base Price</label>
        <input
          type="number"
          value={basePrice}
          onChange={(e) => setBasePrice(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            fontSize: "16px",
            border: "1px solid #ccc",
            borderRadius: "6px",
          }}
        />
      </div>

      {/* ===================================== */}
      {/* CURRENCY */}
      {/* ===================================== */}
      <div style={{ marginBottom: "30px" }}>
        <label style={{ display: "block", marginBottom: 6 }}>Currency</label>
        <input
          type="text"
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
          placeholder="NOK, USD, IQD, EUR..."
          style={{
            width: "100%",
            padding: "10px",
            fontSize: "16px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            textTransform: "uppercase",
          }}
        />
      </div>

      {/* ===================================== */}
      {/* COLOR PRICES */}
      {/* ===================================== */}
      <h2 style={{ margin: "30px 0 10px" }}>Color Prices</h2>

      {colors.map((c, i) => (
        <div key={c.id} style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: 5 }}>
            {c.name}
          </label>
          <input
            type="number"
            value={c.price}
            onChange={(e) => {
              const updated = [...colors];
              updated[i].price = e.target.value;
              setColors(updated);
            }}
            style={{
              width: "100%",
              padding: "10px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          />
        </div>
      ))}

      {/* ===================================== */}
      {/* EQUIPMENT PRICES */}
      {/* ===================================== */}
      <h2 style={{ margin: "30px 0 10px" }}>Equipment Prices</h2>

      {equipment.map((e, i) => (
        <div key={e.id} style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: 5 }}>
            {e.name}
          </label>
          <input
            type="number"
            value={e.price}
            onChange={(event) => {
              const updated = [...equipment];
              updated[i].price = event.target.value;
              setEquipment(updated);
            }}
            style={{
              width: "100%",
              padding: "10px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          />
        </div>
      ))}

      {/* ===================================== */}
      {/* SAVE BUTTON */}
      {/* ===================================== */}
      <button
        onClick={saveChanges}
        disabled={saving}
        style={{
          width: "100%",
          padding: "12px",
          fontSize: "17px",
          borderRadius: "6px",
          backgroundColor: "#111",
          color: "#fff",
          cursor: "pointer",
          marginTop: "30px",
        }}
      >
        {saving ? "Saving..." : "Save All Changes"}
      </button>

      {/* SUCCESS MESSAGE */}
      {saved && (
        <p style={{ marginTop: 15, color: "green" }}>
          Saved successfully!
        </p>
      )}
    </div>
  );
};

export default BuildVoyahConfig;
